import(/* webpackMode: "eager" */ "/builds/PortailVente/portailvente_web_wall/nextweb/src/app/(product-wall)/telephones-mobiles/error.tsx");
